/**
 * REST API namespace for rest requests against blocks namespace.
 *
 * @member  {string}
 */
export const API_BLOCK_NAMESPACE = 'wc/blocks';

export const EMPTY_CART_COUPONS: [] = [];
export const EMPTY_CART_ITEMS: [] = [];
export const EMPTY_CART_CROSS_SELLS: [] = [];
export const EMPTY_CART_FEES: [] = [];
export const EMPTY_CART_ITEM_ERRORS: [] = [];
export const EMPTY_CART_ERRORS: [] = [];
export const EMPTY_SHIPPING_RATES: [] = [];
export const EMPTY_PAYMENT_METHODS: [] = [];
export const EMPTY_PAYMENT_REQUIREMENTS: [] = [];
export const EMPTY_EXTENSIONS: Record< string, unknown > = {};
export const EMPTY_TAX_LINES: [] = [];
